<template>
  <v-card>
    <v-card-title class="mx-3">
      <v-spacer></v-spacer>
      <v-tooltip left v-if="relation.delete_action">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            color="danger"
            @click.stop="$emit('delete', relation)"
            >fa-times
          </v-icon>
        </template>
        <span>
          {{ $t("CRUD.delete") }}
        </span>
      </v-tooltip>
    </v-card-title>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item>
        <v-list-item-content class="text-subtitle-1 align-end text-end my-n4">
          {{ $t("Dish.Fields.dish_practice") + $t("Global.colon") }}
        </v-list-item-content>
        <v-list-item-content class="align-end text-end d-inline pa-1">
          {{
            relation.food_behavior.behavior_code +
            "/" +
            relation.food_behavior.behavior_name
          }}
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list dense>
      <v-list-item>
        <v-list-item-content class="text-subtitle-1 align-end text-end my-n4">
          {{ $t("Dish.Fields.cost_card") + $t("Global.colon") }}
        </v-list-item-content>
        <v-list-item-content class="align-end text-end d-inline pa-1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <a
                  class="text-wrap text-caption"
                  text-color="primary"
                  style="text-decoration: none"
                  @click="dialog = true"
                >
                  {{
                    relation.food_formula.formula_code +
                    "/" +
                    relation.food_formula.formula_name
                  }}
                </a>
              </span>
            </template>
            {{ $t("Dish.costCardInfo") }}
          </v-tooltip>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <CostCardInfoDialog
      v-model="dialog"
      :formulaId="relation.food_formula_id"
    />
  </v-card>
</template>
<script>
import CostCardInfoDialog from "./CostCardInfoDialog";
export default {
  name: "FoodRelations",

  props: {
    value: Object,
    defaultUnit: String,
    mode: String,
    editUnit: Boolean,
    serverErrors: Array,
  },

  components: {
    CostCardInfoDialog,
  },

  data: () => ({
    relation: {},
    food_behavior: {},
    food_formula: {},
    dialog: false,
  }),

  methods: {},

  watch: {
    value: {
      immediate: true,
      handler() {
        this.relation = this.value;
      },
    },
  },
};
</script>